/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';
import { getApiPath } from '../../store-helpers';

const state = {
  blacklists: [],
  limit: 5,
  keywordFilter: '',
};

const getters = {
  blacklists: state => state.blacklists,
  limit: state => state.limit,
  keywordFilter: state => state.keywordFilter,
};

const actions = {
  fetch({ commit }, payload) {
    const limit = `&limit=${payload.limit ? payload.limit : state.limit}`;
    let keyword = '';
    if (payload.keyword) {
      commit(mTypes.SET_KEYWORD_FILTER, payload.keyword);
      keyword = `&q=${payload.keyword}`;
    }
    return Vue.http.get(`${getApiPath(payload.user)}/blacklists/list?${keyword}${limit}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, blacklists) {
    state.blacklists = blacklists.data;
  },
  [mTypes.SET_LIMIT](state, limit) {
    state.limit = limit;
  },
  [mTypes.REMOVE_DATA](state, blacklistItemId) {
    const index = state.blacklists.items.findIndex(obj => obj.id === blacklistItemId);
    state.blacklists.items.splice(index, 1);
    state.blacklists.total -= 1;
  },
  [mTypes.CLEAR_STATE](state) {
    state.blacklists = {};
  },
  [mTypes.REMOVE_DATAS](state, ids) {
    const items = state.blacklists.items.filter((obj) => {
      const findItem = ids.find(id => id === obj.id);

      if (findItem) return false;
      return true;
    });

    state.blacklists.items = items;
  },
  [mTypes.SET_KEYWORD_FILTER](state, keywordFilter) {
    state.keywordFilter = keywordFilter;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/landlord/blacklists.js